/**
 * Detail sheets render a contact's `lastEmail` / `lastMeeting` / `nextMeeting`
 * fields directly as React children. Those fields are expected to be formatted
 * date strings, but a raw GraphQL Engagement object (`{ __typename, id,
 * displayName, startTime }`) can leak in when a caller passes an unformatted
 * contact — rendering an object as a child throws React error #31 and crashes
 * the page.
 *
 * This guard returns a shallow copy with any non-string value in those fields
 * replaced by `undefined`, so the render path falls back to "-" instead of
 * crashing. Caller-agnostic defense-in-depth; the real formatting still happens
 * upstream.
 */
const DATE_DISPLAY_FIELDS = ['lastEmail', 'lastMeeting', 'nextMeeting'] as const;

export function sanitizeDisplayDates<T extends Record<string, unknown>>(person: T): T {
  const out = { ...person };
  for (const key of DATE_DISPLAY_FIELDS) {
    if (out[key] != null && typeof out[key] !== 'string') {
      (out as Record<string, unknown>)[key] = undefined;
    }
  }
  return out;
}
